/** @graphql cc **/

import gql from 'graphql-tag';

export const PageTreeChildrenQuery = gql`
	query PageTreeChildrenQuery(
		$contentId: ID!
		$statuses: [PTGraphQLPageStatus]
		$first: Int
		$after: String
		$isSuperAdmin: Boolean!
	) {
		ptpage(id: $contentId, status: $statuses) {
			id
			title
			status
			blank
			hasChildren
			hasRestrictions @include(if: $isSuperAdmin)
			hasInheritedRestrictions @include(if: $isSuperAdmin)
			type
			subType
			links {
				webui
			}
			properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
				nodes {
					id
					key
					value
					version {
						number
					}
				}
			}
			children(first: $first, after: $after) {
				nodes {
					id
					title
					status
					blank
					hasChildren
					hasRestrictions @include(if: $isSuperAdmin)
					hasInheritedRestrictions @include(if: $isSuperAdmin)
					type
					subType
					links {
						webui
					}
					properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
						nodes {
							id
							key
							value
							version {
								number
							}
						}
					}
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}
`;
